export const content = {
  localization: {
    title: "Localization",
    text: `Localization is the process of adapting information or communication to align with the cultural, linguistic, and social expectations of a specific audience. Unlike translation, which focuses only on language, localization also adjusts context, examples, and cultural references.

This may include using local currency or changing date formats, but it does not involve physical changes, such as changing clothing materials for climate. However, modifying language or tone to fit different social settings can be considered a form of cultural localization.`,
    sources: [
      "https://resources.gala-global.org/accessibility-localization/",
      "https://www.vistatec.com/localization-for-all-advancing-accessibility-and-inclusion-in-a-globalized-world/",
    ],
    imageUrl:
      "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=400", // Placeholder
  },
  colorblindness: {
    title: "Color Blindness",
    text: `Color blindness is a visual condition that affects color perception, most commonly red and green. The most common type, red-green color blindness, is inherited through the X chromosome. People with red-green color blindness do not see only red and green, but may have difficulty distinguishing between certain shades.

Although many cases are inherited, they can also develop later in life due to eye disease, injury, aging, or certain medications. Complete color blindness is rare and should not be assumed.`,
    sources: [
      "https://www.colourblindawareness.org/colour-blindness/",
      "https://www.nei.nih.gov/eye-health-information/eye-conditions-and-diseases/color-blindness",
    ],
    imageUrl:
      "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=400", // Placeholder
  },
  dyslexia: {
    title: "Dyslexia",
    text: `Dyslexia is a neurological learning disability that primarily affects reading and language processing. It is not a vision problem and does not affect intelligence. People with dyslexia may have difficulty connecting written letters to spoken sounds, not how letters visually appear.

        Dyslexia cannot be cured, but it can be effectively supported through early intervention, structured reading instruction, and classroom accommodations.`,
    sources: [
      "https://dyslexiaida.org/definition-of-dyslexia/",
      "https://www.losdschools.org/student-services/dyslexia-handbook/definition-of-dyslexia",
    ],
    imageUrl:
      "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=400", // Placeholder
  },
};
